import { Directive, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, NgForm } from '@angular/forms';
import { IComponentDef } from '../../shared/interfaces';

@Directive()
export abstract class RWidgetFormRenderBase {
  /** 父级组件 */
  @Input() parentComponent: IComponentDef;

  /** 要渲染的组件 */
  @Input() component: IComponentDef;

  /** disabled */
  @Input() disabled: boolean = false;

  /** 是否显示按钮 */
  @Input() showButton: boolean = true;

  /** 是否显示边框 */
  // @Input() bordered: boolean = false;

  getLabelWidth(item: IComponentDef): string {
    if (typeof item.labelWidth !== 'number') {
      item.labelWidth = 100;
    }

    return `${item.labelWidth}px`;
  }

  constructor() {}
}
